import { render, staticRenderFns } from "./userandpswsetup.vue?vue&type=template&id=4411efdf&scoped=true&"
import script from "./userandpswsetup.vue?vue&type=script&lang=js&"
export * from "./userandpswsetup.vue?vue&type=script&lang=js&"
import style0 from "./userandpswsetup.vue?vue&type=style&index=0&id=4411efdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4411efdf",
  null
  
)

export default component.exports